module.exports = __webpack_public_path__ + "fonts/vodafone-light.woff";